import Vue from 'vue';
// import { GA } from './ga-events';
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
import { gaEvent } from './ga-events';
import { clickOutside } from './click-outside';

// Vue.use(GA);
Vue.directive('gaEvent', gaEvent);
Vue.directive('click-outside', clickOutside);
Vue.directive('tooltip', VTooltip);
